import { Modal, Accordion, Row, Col, Image } from 'react-bootstrap';
import ReactPlayer from "react-player"
import React, { useState } from 'react';

import AngelynProfile from '../img/AngelynProfile.png';
import AnthonerProfile from '../img/AnthonerProfile.png';

import ctl1 from '../img/ctl/ctl1.png';
import ctl2 from '../img/ctl/ctl2.png';
import ctl3 from '../img/ctl/ctl3.png';
import ctl4 from '../img/ctl/ctl4.png';

import mitec1 from '../img/mitec/mitec1.png';
import mitec2 from '../img/mitec/mitec2.png';
import mitec3 from '../img/mitec/mitec3.png';
import mitec4 from '../img/mitec/mitec4.png';

import anjc1 from '../img/anjc/anjc1.png';
import anjc2 from '../img/anjc/anjc2.png';
import anjc3 from '../img/anjc/anjc3.png';
import anjc4 from '../img/anjc/anjc4.png';
import anjc5 from '../img/anjc/anjc5.png';

import kgc1 from '../img/kgc/kgc1.png';
import kgc2 from '../img/kgc/kgc2.png';
import kgc3 from '../img/kgc/kgc3.png';
import kgc4 from '../img/kgc/kgc4.png';

import mern11 from '../img/mern1/mern11.png';
import mern12 from '../img/mern1/mern12.png';
import mern13 from '../img/mern1/mern13.png';
import mern14 from '../img/mern1/mern14.png';
import mern15 from '../img/mern1/mern15.png';
import mern16 from '../img/mern1/mern16.png';

import dermestetics from '../img/cld/dermestetics.png';
import handlednow from '../img/cld/handlednow.png';
import impactindy from '../img/cld/impactindy.jpg';
import inspireresults from '../img/cld/inspireresults.jpg';
import instesahr from '../img/cld/instesahr.png';
import truckers411 from '../img/cld/truckers411.png';

/**
 * PGIT Websites
 */
import eso from '../img/pgit/eso.png';
import pcares from '../img/pgit/pcares.png';
import pcleans from '../img/pgit/pcleans.png';
import pgnj from '../img/pgit/pgnj.png';
import pgny from '../img/pgit/pgny.jpg';
import qhs from '../img/pgit/qhs.png';

/**
 * PGIT Landing Page
 */
import lp_cdpap from '../img/pgit/lp_cdpap.png';
import lp_eso from '../img/pgit/lp_eso.png';
import lp_njcleans from '../img/pgit/lp_njcleans.png';
import lp_njhomecares from '../img/pgit/lp_njhomecares.png';
import lp_pcares from '../img/pgit/lp_pcares.png';
import lp_uhc from '../img/pgit/lp_uhc.jpg';

import seo01 from '../img/seo/SEO1.png';
import seo02 from '../img/seo/SEO2.png';

import albato01 from '../img/albato/albato01.png';
import albato02 from '../img/albato/albato02.png';
import albato03 from '../img/albato/albato03.png';
import albato04 from '../img/albato/albato04.png';

import n8n01 from '../img/n8n/n8n01.png';

import AccordionBody from 'react-bootstrap/esm/AccordionBody';


/**
 * Video links
 * 
 */



function Projects() {

    const YTVideo1 = 'https://www.youtube.com/watch?v=o2Kfpm00eUU'
    const YTVideo2 = 'https://www.youtube.com/watch?v=oYh4Jdfikhc'
    const YTVideo3 = 'https://www.youtube.com/watch?v=6mkSsT0nrpY'
    const YTVideo4 = 'https://www.youtube.com/watch?v=LWpnQyqKEr0'
    const YTVideo5 = 'https://www.youtube.com/watch?v=JOMNlYLZpPI'
    const YTVideo6 = 'https://www.youtube.com/watch?v=_v36l6MIOCs'
    const YTVideo7 = 'https://www.youtube.com/watch?v=tUMG1kDrXuU'
    const YTVideo8 = 'https://www.youtube.com/watch?v=HbgJXLUC99s'
    const YTVideo9 = 'https://www.youtube.com/watch?v=nbQQpJAzgKE'
    const YTVideo10 = 'https://www.youtube.com/watch?v=zXPRSBdAdA4'
    const YTVideo11 = 'https://www.youtube.com/watch?v=H-VooNqn5wk'
    const YTVideo12 = 'https://www.youtube.com/watch?v=v0Z_CROeH28'
    const YTVideo13 = 'https://www.youtube.com/watch?v=s47Z7YW_a14'
    const YTVideo14 = 'https://youtu.be/JQ_yvxOiyzY'
    const YTVideo15 = 'https://youtu.be/IOMifFBlAzQ'
    const YTVideo16 = 'https://youtu.be/jJ2F6q3QlJQ'
    const YTVideo17 = 'https://youtu.be/EDRMhnmEvg4'
    const YTVideo18 = 'https://youtu.be/62Zcpzd4g5Y'
    const YTVideo19 = 'https://youtu.be/9iQsOEkMxRw'
    const YTVideo20 = 'https://www.youtube.com/watch?v=jpIcBFz8LM8'
    const YTVideo21 = 'https://www.youtube.com/watch?v=rx9PW918MDo'
    const YTVideo22 = 'https://www.youtube.com/watch?v=LFS-EEg3edg'
    const YTVideo23 = 'https://www.youtube.com/watch?v=myCh4PnfbO0'


    return (
        <Accordion>
            <Accordion.Item eventKey="aut00">
                <Accordion.Header>
                    <h3>Automation</h3>
                </Accordion.Header>
                <AccordionBody>

                    <Accordion>
                        <Accordion.Item eventKey="auto2">
                            <Accordion.Header>
                                <h4>n8n</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>  
                                        <h5>Updating Custom Post by adding GEO Schema</h5>                                      
                                        <Image fluid src={n8n01} />
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="auto1">
                            <Accordion.Header>
                                <h4>Albato</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>  
                                        <h5>Wordpress Landing page to Google Sheets to Email Applicatnt and Email Admin </h5>                                      
                                        <Image fluid src={albato01} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>    
                                        <h5>Mailchimp Monotring Campaign's Open and Click Rate Create Asana Task</h5>                                    
                                        <Image fluid src={albato02} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>  
                                        <h5>Monito Email from recruit and create Asana Task</h5>                                      
                                        <Image fluid src={albato03} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>    
                                        <h5>Other Automation Created</h5>                                    
                                        <Image fluid src={albato04} />
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="seo00">
                <Accordion.Header>
                    <h3>SEO</h3>
                </Accordion.Header>
                <AccordionBody>

                    <Accordion>
                        <Accordion.Item eventKey="seo1">
                            <Accordion.Header>
                                <h4>Priority Groups SEO</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>  
                                        <h5>Before</h5>                                      
                                        <Image fluid src={seo01} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>    
                                        <h5>After</h5>                                    
                                        <Image fluid src={seo02} />
                                    </Col>
                                </Row>                          

                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <h3>WEB Projects</h3>
                </Accordion.Header>
                <AccordionBody>

                    <Accordion>
                        <Accordion.Item eventKey="web8">
                            <Accordion.Header>
                                <h4>Website Development using Grawt: Landing pages - Priority Groups</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>                                        
                                        <Image fluid src={lp_cdpap} />
                                    </Col>
                                    <Col>                                        
                                        <Image fluid src={lp_eso} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>                                        
                                        <Image fluid src={lp_njcleans} />
                                    </Col>
                                    <Col>                                        
                                        <Image fluid src={lp_njhomecares} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>                                        
                                        <Image fluid src={lp_pcares} />
                                    </Col>
                                    <Col>                                        
                                        <Image fluid src={lp_uhc} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web7">
                            <Accordion.Header>
                                <h4>Website Development using Wordpress/Elementor - Priority Groups</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        <a href="https://prioritygroups.org/" target="_blank" rel="noopener noreferrer">Priority Groups</a>
                                        <Image fluid src={pgny} />
                                    </Col>
                                    <Col>
                                        <a href="https://prioritygroupsnj.org/" target="_blank" rel="noopener noreferrer">Priority Groups NJ</a>
                                        <Image fluid src={pgnj} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href="https://prioritycareshs.com/" target="_blank" rel="noopener noreferrer">Priority Cares Home Services</a>
                                        <Image fluid src={pcares} />
                                    </Col>
                                    <Col>
                                        <a href="https://prioritycleans.com/" target="_blank" rel="noopener noreferrer">Priority Cleans</a>
                                        <Image fluid src={pcleans} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href="https://qhstaff.com/" target="_blank" rel="noopener noreferrer">Quality Healthcare Staffing</a>
                                        <Image fluid src={qhs} />
                                    </Col>
                                    <Col>
                                        <a href="https://esoconsultants.com/" target="_blank" rel="noopener noreferrer">ESO Consultants</a>
                                        <Image fluid src={eso} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web6">
                            <Accordion.Header>
                                <h4>Website Development using Wordpress/Elementor - Clickloop</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        <a href="https://impactindygroup.com/" target="_blank" rel="noopener noreferrer">Impact Indy</a>
                                        <Image fluid src={impactindy} />
                                    </Col>
                                    <Col>
                                        <a href="https://handlednow.com/" target="_blank" rel="noopener noreferrer">HandledNow</a>
                                        <Image fluid src={handlednow} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href="https://truckers411.com/" target="_blank" rel="noopener noreferrer">Truckers411</a>
                                        <Image fluid src={truckers411} />
                                    </Col>
                                    <Col>
                                        <a href="https://intesaconsultingllc.com/" target="_blank" rel="noopener noreferrer">IntesaHR</a>
                                        <Image fluid src={instesahr} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href="https://inspireresults.com/" target="_blank" rel="noopener noreferrer">Inspire Results</a>
                                        <Image fluid src={inspireresults} />
                                    </Col>
                                    <Col>
                                        <a href="https://dermestetics.com/" target="_blank" rel="noopener noreferrer">Dermestetics</a>
                                        <Image fluid src={dermestetics} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web5">
                            <Accordion.Header>
                                <h4>WEB PROFILE USING REACT.JS</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        <a href="https://an2ner-profile.onrender.com" target="_blank" rel="noopener noreferrer">Anthoner Monzon's Profile</a>
                                        <Image fluid src={AnthonerProfile} />
                                    </Col>
                                    <Col>
                                        <a href="https://angelynmonzon-porfolio.onrender.com" target="_blank" rel="noopener noreferrer">Angelyn Monzon's Profile</a>
                                        <Image fluid src={AngelynProfile} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web4">
                            <Accordion.Header>
                                <h4>Site for Non-Profit Org using CakePHP Framework</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        CTL Sponsor Login
                                        <Image fluid src={ctl1} />
                                    </Col>
                                    <Col>
                                        CTL Sponsor Landing Page
                                        <Image fluid src={ctl2} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        CTL Admin Login
                                        <Image fluid src={ctl3} />
                                    </Col>
                                    <Col>
                                        CTL Admin Dashboard
                                        <Image fluid src={ctl4} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web3">
                            <Accordion.Header>
                                <h4>Internal Site for MITEC using CakePHP Framework and .NET API</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        MITEC Login
                                        <Image fluid src={mitec1} />
                                    </Col>
                                    <Col>
                                        MITEC Time Record Entry
                                        <Image fluid src={mitec2} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        MITEC Time Record Entry
                                        <Image fluid src={mitec3} />
                                    </Col>
                                    <Col>
                                        MITEC
                                        <Image fluid src={mitec4} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web2">
                            <Accordion.Header>
                                <h4>ANJC Page Created using CakePHP Framework</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        ANJC Landing Page
                                        <Image fluid src={anjc1} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        ANJC Admin Login
                                        <Image fluid src={anjc2} />
                                    </Col>
                                    <Col>
                                        ANJC Admin Dashboard
                                        <Image fluid src={anjc3} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        ANJC User Dashboard
                                        <Image fluid src={anjc4} />
                                    </Col>
                                    <Col>
                                        ANJC User Editor
                                        <Image fluid src={anjc5} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web1">
                            <Accordion.Header>
                                <h4>KGC Member's registration and monitoring Created using CakePHP Framework</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        KGC Admin Login
                                        <Image fluid src={kgc1} />
                                    </Col>
                                    <Col>
                                        KGC Admin Member Dashboard
                                        <Image fluid src={kgc2} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        KGC Admin Member Editor
                                        <Image fluid src={kgc3} />
                                    </Col>
                                    <Col>
                                        KGC Registration
                                        <Image fluid src={kgc4} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="web0">
                            <Accordion.Header>
                                <h4>Example Login and CRUD using MERN</h4>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col>
                                        Login Page
                                        <Image fluid src={mern11} />
                                    </Col>
                                    <Col>
                                        User List
                                        <Image fluid src={mern12} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        User Editor
                                        <Image fluid src={mern13} />
                                    </Col>
                                    <Col>
                                        Side Menus
                                        <Image fluid src={mern14} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        Supplier List
                                        <Image fluid src={mern15} />
                                    </Col>
                                    <Col>
                                        Supplier Editor
                                        <Image fluid src={mern16} />
                                    </Col>
                                </Row>

                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
                <Accordion.Header>
                    <h3>Video Editing/LiveStreaming Projects</h3>
                </Accordion.Header>
                <AccordionBody>

                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <h4>KGC LiveStreaming</h4>
                            </Accordion.Header>
                            <AccordionBody>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo22}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo23}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>


                            </AccordionBody>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                <h4>Video Greetings</h4>
                            </Accordion.Header>
                            <AccordionBody>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo21}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo20}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>


                            </AccordionBody>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>
                                <h4>Music Videos</h4>
                            </Accordion.Header>
                            <AccordionBody>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo18}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo19}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>


                            </AccordionBody>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header>
                                <h4>After Effects Examples</h4>
                            </Accordion.Header>
                            <AccordionBody>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo16}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo17}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>


                            </AccordionBody>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header>
                                <h4>Cambria Slideshow Presentation</h4>
                            </Accordion.Header>
                            <AccordionBody>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo14}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo15}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>


                            </AccordionBody>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5">
                            <Accordion.Header>
                                <h4>ANJC Videos 2021 - 2023</h4>
                            </Accordion.Header>
                            <AccordionBody>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo12}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo13}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo1}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                        <br />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo2}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo3}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                    <Col>
                                        <ReactPlayer
                                            url={YTVideo4}
                                            pip={true}
                                            width="100%"
                                            controls={true}
                                        />
                                    </Col>
                                </Row>


                            </AccordionBody>
                        </Accordion.Item>
                    </Accordion>
                </AccordionBody>
            </Accordion.Item>
        </Accordion>
    );
}

export default Projects;